import { MijnRoute } from '../../mijn-navigatie.model';

export const SELF_SERVICE_GELDZAKEN_KIND: MijnRoute = {
    path: 'geldzaken-kind',
    navigationEvent: 'toGeldzakenKind',
    regex: /^\/zelf-regelen\/geldzaken-kind$/,
    webcomponent: 'mijn-klant-geldzaken-kind-webcomponent'
};
